
<p class="title-section">Alertas/Riesgos</p>

<div class="risksAlerts-panel" >
  <div class="risksAlerts" *ngFor="let checkRiskAlert of checkRisksAlerts; let i = index">
    <div class="control" >
        <div class="toggle">
          <mat-slide-toggle [checked]="checkRiskAlert.activeSelected" (change)="onCheckRiskAlertChange(checkRiskAlert,i)"
            [(ngModel)]="checkRiskAlert.activeSelected" [disabled]="readOnlyContent || riskAlertDisabled(checkRiskAlert)">
            {{checkRiskAlert.activeSelected ? checkRiskAlert.risksAlertsLabelActive : checkRiskAlert.risksAlertsLabelInactive}}
          </mat-slide-toggle>
        </div>
        <div class="fields">
          <mat-form-field *ngIf="checkRiskAlert.activeSelected && (checkRiskAlert.risksAlertsType=='deep')">
            <mat-label>Profundidad(Metros)</mat-label>
            <div matTooltip={{checkRiskAlert.risksAlertsLabel}}>
              <input matInput type="number" min="0" (change)="onCheckRiskAlertChange(checkRiskAlert,i)"
                [(ngModel)]="checkRiskAlert.risksAlertsLabel" [disabled]="readOnlyContent || riskAlertDisabled(checkRiskAlert)" />
            </div>
            <mat-hint class="alert" *ngIf="!readOnlyContent">Este campo es obligatorio.</mat-hint>
          </mat-form-field>
          <mat-form-field class="task" *ngIf="checkRiskAlert.activeSelected && (checkRiskAlert.risksAlertsType=='variable')">
            <mat-label>Explicar las variantes introducidas</mat-label>
            <div matTooltip={{checkRiskAlert.risksAlertsLabel}}>
              <input matInput type="text" (change)="onCheckRiskAlertChange(checkRiskAlert,i)"
                [(ngModel)]="checkRiskAlert.risksAlertsLabel" [disabled]="readOnlyContent || riskAlertDisabled(checkRiskAlert)" />
            </div>
            <mat-hint class="alert" *ngIf="!readOnlyContent">Este campo es obligatorio.</mat-hint>
          </mat-form-field>
        </div>
    </div>
  </div>
  
</div>
<div class="risksAlerts">
  <div class="top">
    <p>Completar en la sección “Elementos de barreras” aquellos que pudieran verse afectados por las “Alertas / Riesgos”, anteriormente descriptos</p>
  </div>
  <div class="risksAlerts-actions" *ngIf="!readOnlyContent">
    <button mat-button class="save" title="Guardar" (click)="save()">
      <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
    </button>
  </div>
</div>